import { Outlet } from "react-router";
import { Navbar } from "./Navbar";
import { useState } from "react";

export default function NavLayout() {
  const [collapsed, setCollapsed] = useState(true);
  return (
    <>
      <Navbar collapsed={collapsed} setCollapsed={setCollapsed} />
      <div className="wrapper" onClick={() => setCollapsed(true)}>
        <Outlet />
      </div>
    </>
  );
}
